import * as React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import Dashboard from './layouts/dashboard'
import SignInView from './pages/sign-in-view';
import CallbackView from './pages/callback-view';
import AmaView from './pages/ama-view';
import AmaV2View from 'pages/ama-v2-view';
import SaiView from './pages/sai-view';
import AsrView from './pages/asr-view';
import SchemaView from './pages/schema-view';
import DsmView from './pages/dsm-view';
import ErrorView from './pages/error-view';
import NotFoundView from './pages/not-found-view';
import HsqView from './pages/hsq-view';
import DataExplorerView from './pages/data-explorer-view';
import JobsView from './pages/jobs-view';
import EventsView from './pages/events-view';
import AdminUtilityView from './pages/admin-utility-view';
import ApiTester from 'components/api-tester';

import { useAmaWorkflowContext } from './context/ama-workflow-provider';
import { useAmaV2Context } from 'context/ama-v2-provider';
import { useAuth } from './context/auth-provider';
import { AuthChallange } from './data/enums';
import './index.css';

const router = createBrowserRouter([
  { path: "/", element: <Root/>,   
      children: [        

        { path: "ama-v2", Component: AmaV2View, children: 
          [
            { path: "clients", Component: AmaView },
            { path: "snapshots", Component: AmaView },
            { path: "dashboard-processor", Component: AmaView },
            { path: "file-explorer", Component: AmaView }
          ] 
        },
        { path: "ama", Component: AmaView, children: 
          [
            { path: "clients", Component: AmaView },
            { path: "snapshots", Component: AmaView },
            { path: "help", Component: AmaView },
            { path: "schema", Component: AmaView }       
          ] 
        },        
        { path: "dsm", Component: DsmView },  
        { path: "sai", Component: SaiView },        
        { path: "asr", Component: AsrView },
        { path: "hsq", Component: HsqView },
        { path: "data-explorer", Component: DataExplorerView },        
        { path: "jobs", Component: JobsView },
        { path: "events", Component: EventsView },
        { path: "admin-utility", Component: AdminUtilityView },
        { path: "error", Component: ErrorView },
        { path: "", element: <Navigate to="/ama-v2" replace={true} />},
        { path: "*", Component: NotFoundView }        
      ]
  },
  { path: "schema", Component: SchemaView },
  { path: "callback", Component: CallbackView },
]);

export default function App() {
  return <RouterProvider router={router} />;
}

export function Root() {
  const { user, logout } = useAuth();
  const { loadClients, loadSnapshots } = useAmaWorkflowContext();
  const { loadClients: loadClientsV2, loadSnapshots: loadSnapshotsV2 } = useAmaV2Context();
  const [requiresInit, setRequiresInit] = React.useState(true);

  React.useEffect(() => {
    if (!user) {
      // No user present, show login screen
      setRequiresInit(true);
    } else if (requiresInit) {
      // Session is valid, initialize data
      // loadClients();
      loadClientsV2();
      loadSnapshotsV2()
      // loadSnapshots();
      setRequiresInit(false);
    }
  }, [user]);

  return (
    <>
      {!user && <SignInView />}
      {user && <Dashboard />}
    </>
  );
}
